import { z } from 'zod';

const OptionalIdSchema = z.string().trim().min(1).optional().catch(undefined);

const TerminalSessionOutputSchema = z.object({
  backgrounded: z.boolean().optional().catch(undefined),
  jobId: OptionalIdSchema,
  ptyId: OptionalIdSchema,
});

const TerminalSessionInputSchema = z.object({
  action: z
    .enum(['open', 'send', 'read', 'interrupt', 'close'])
    .optional()
    .catch(undefined),
  sessionId: OptionalIdSchema,
});

export type TerminalSessionInfo =
  | { kind: 'background'; jobId?: string }
  | { kind: 'interactive'; ptyId?: string; opensSession: boolean };

export const getTerminalSessionInfo = ({
  input,
  output,
}: {
  input: unknown;
  output: unknown;
}): TerminalSessionInfo | undefined => {
  const parsedOutput = TerminalSessionOutputSchema.safeParse(output);
  const parsedInput = TerminalSessionInputSchema.safeParse(input);
  const sessionOutput = parsedOutput.success ? parsedOutput.data : undefined;
  const sessionInput = parsedInput.success ? parsedInput.data : undefined;

  if (sessionOutput?.backgrounded) {
    return { kind: 'background', jobId: sessionOutput.jobId };
  }

  if (!sessionInput?.action && !sessionOutput?.ptyId) {
    return undefined;
  }

  const opensSession = sessionInput?.action === 'open';

  return {
    kind: 'interactive',
    ptyId:
      sessionOutput?.ptyId ??
      (opensSession ? undefined : sessionInput?.sessionId),
    opensSession,
  };
};
